import { useEffect, useState } from "react";

// Seconds left before a new code may be requested; restarts with `restartKey`.
export const useCountdown = (seconds: number, restartKey: number) => {
  const [secondsLeft, setSecondsLeft] = useState(seconds);

  useEffect(() => {
    setSecondsLeft(seconds);
    const interval = window.setInterval(
      () => setSecondsLeft((left) => Math.max(left - 1, 0)),
      1000,
    );
    return () => window.clearInterval(interval);
  }, [seconds, restartKey]);

  return secondsLeft;
};

export const formatSeconds = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
